module.exports = __webpack_public_path__ + "img/joaquinniemann.c103aa5a.jpg";